// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import api from '../services/api';
// import { Search, MapPin, Briefcase } from 'lucide-react';
// import { stats } from '../mock/mockData'; 

// const Hero = () => {
//   const [city, setCity] = useState('');
//   const [role, setRole] = useState('');
//   const [dynamicCities, setDynamicCities] = useState([]);
  
//   const [allJobs, setAllJobs] = useState([]);
//   const [suggestions, setSuggestions] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
  
//   // Dynamic Banner State
//   const [bannerData, setBannerData] = useState(null);
  
//   const dropdownRef = useRef(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchHeroData = async () => {
//       try {
//         const [cityRes, jobsRes, bannerRes] = await Promise.all([
//           api.get("/nav-filters"),
//           api.get("/public-jobs"),
//           api.get("/active-banner").catch(() => ({ data: { banner: null } })) // Fallback agar banner API fail ho
//         ]);
        
//         setDynamicCities(cityRes.data.cities || []);
//         setAllJobs(Array.isArray(jobsRes.data) ? jobsRes.data : []);
        
//         if (bannerRes.data && bannerRes.data.banner) {
//           setBannerData(bannerRes.data.banner);
//         }
//       } catch (error) {
//         console.error("Error fetching data for hero section", error);
//       }
//     };
//     fetchHeroData();

//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleInputChange = (e) => {
//     const val = e.target.value;
//     setRole(val);

//     if (val.trim().length > 0) {
//       const filtered = allJobs.filter(job =>
//         (job.title && job.title.toLowerCase().includes(val.toLowerCase())) ||
//         (job.company && job.company.toLowerCase().includes(val.toLowerCase())) ||
//         (job.category && job.category.toLowerCase().includes(val.toLowerCase()))
//       );

//       const uniqueTitles = [...new Set(filtered.map(j => j.title || j.category).filter(Boolean))].slice(0, 5);
//       setSuggestions(uniqueTitles);
//       setShowDropdown(uniqueTitles.length > 0);
//     } else {
//       setShowDropdown(false);
//     }
//   };

//   const handleSuggestionClick = (suggestion) => {
//     setRole(suggestion);
//     setShowDropdown(false);
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     setShowDropdown(false);

//     let queryParams = new URLSearchParams();
//     if (city) queryParams.append('city', city);
//     if (role) queryParams.append('skill', role);

//     navigate(`/job-listing?${queryParams.toString()}`);
//   };

//   return (
//     // <section
//     //   className="relative transition-colors duration-300 overflow-visible bg-gray-900 text-white"
//     //   style={{ 
//     //     backgroundImage: bannerData?.image_url ? `url(${bannerData.image_url})` : 'linear-gradient(135deg, #060606ff 0%, #393a3dff 55%, #8f929aff 100%)',
//     //     backgroundSize: 'cover',
//     //     backgroundPosition: 'center'
//     //   }}
//     // >
//     //   {/* Dark Overlay taaki text clear dikhe */}
//     //   <div className="absolute inset-0 bg-black/60 pointer-events-none" />

//     //   <div className="absolute inset-0 opacity-20 pointer-events-none overflow-hidden">
//     //     <div className="absolute -top-16 -left-16 w-72 h-72 rounded-full bg-white/10 blur-3xl" />
//     //     <div className="absolute top-20 right-10 w-96 h-96 rounded-full bg-[#FED547]/20 blur-3xl" />
//     //     <div className="absolute bottom-10 left-1/3 w-80 h-80 rounded-full bg-blue-300/10 blur-3xl" />
//     //   </div>

//     //   <div className="relative overflow-visible max-w-[1200px] mx-auto px-4 pt-16 pb-24 text-center z-10">
        
//     //     {/* Subtitle / Tag */}
//     //     <div className="inline-flex items-center gap-2 mb-4 px-4 py-1.5 rounded-full bg-white/10 border border-white/25 text-white/90 text-xs backdrop-blur-md">
//     //       <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
//     //       {bannerData?.subtitle || "India's No.1 Blue Collar & Entry-Level Job Portal"}
//     //     </div>

//     //     {/* Dynamic Title */}
//     //     <h1 className="text-white font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight max-w-4xl mx-auto">
//     //       {bannerData?.title || "Find the best job near you"}
//     //     </h1>

//     //     <p className="text-orange-200 font-medium mt-3 text-lg">
//     //       <span className="text-white font-bold">{stats.vacancies}</span> active job vacancies to grab
//     //     </p>

//     //     {/* Optional Banner Link */}
//     //     {bannerData?.link_url && (
//     //       <div className="mt-4">
//     //         <a 
//     //           href={bannerData.link_url} 
//     //           target="_blank" 
//     //           rel="noopener noreferrer"
//     //           className="inline-block bg-yellow-500 text-black text-xs font-extrabold px-5 py-2 rounded-xl hover:bg-yellow-400 transition-colors shadow-lg"
//     //         >
//     //           Learn More →
//     //         </a>
//     //       </div>
//     //     )}

//     //     {/* Search Bar Container - Banner ke thoda niche aur better spaced design */}
//     //     <form onSubmit={handleSearch} className="mt-12 max-w-3xl mx-auto">
//     //       <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-3 flex flex-col md:flex-row items-stretch md:items-center gap-3 transition-colors duration-300 relative border border-gray-100 dark:border-gray-700">
            
//     //         {/* City Dropdown */}
//     //         <div className="flex items-center gap-2 flex-1 px-4 py-3 bg-gray-50 dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 transition-colors duration-300 w-full">
//     //           <MapPin className="w-5 h-5 text-gray-700 dark:text-white shrink-0" />
//     //           <select
//     //             value={city}
//     //             onChange={(e) => setCity(e.target.value)}
//     //             className="w-full text-sm font-semibold text-gray-700 dark:text-white bg-transparent outline-none appearance-none cursor-pointer"
//     //           >
//     //             <option value="" className="bg-white dark:bg-gray-900">Select City</option>
//     //             {dynamicCities.map((c, index) => (
//     //               <option key={index} value={c} className="bg-white dark:bg-gray-900">{c}</option>
//     //             ))}
//     //           </select>
//     //         </div>

//     //         {/* Dynamic Search Input with Upward Modal Dropdown */}
//     //         <div ref={dropdownRef} className="relative flex items-center gap-2 flex-1 px-4 py-3 bg-gray-50 dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 transition-colors duration-300 w-full">
//     //           <Briefcase className="w-5 h-5 text-gray-700 dark:text-white shrink-0" />
//     //           <input
//     //             type="text"
//     //             value={role}
//     //             onChange={handleInputChange}
//     //             onFocus={() => { if (role.trim() && suggestions.length > 0) setShowDropdown(true); }}
//     //             placeholder="Enter job role, skill or company"
//     //             autoComplete="off"
//     //             className="w-full text-sm font-semibold text-gray-700 dark:text-white bg-transparent outline-none placeholder:text-gray-400 dark:placeholder-gray-400"
//     //           />

//     //           {/* Suggestions Dropdown opening upwards (Modal style) */}
//     //           {showDropdown && suggestions.length > 0 && (
//     //             <div className="absolute left-0 right-0 bottom-[130%] mb-2 bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl overflow-hidden text-left z-[99999]">
//     //               <ul className="max-h-60 overflow-y-auto divide-y divide-gray-800">
//     //                 {suggestions.map((suggestion, index) => (
//     //                   <li
//     //                     key={index}
//     //                     onMouseDown={(e) => {
//     //                       e.preventDefault();
//     //                       handleSuggestionClick(suggestion);
//     //                     }}
//     //                     className="px-5 py-3.5 hover:bg-gray-800 cursor-pointer text-sm text-white flex items-center gap-3 transition-colors"
//     //                   >
//     //                     <Search className="w-4 h-4 text-yellow-400 shrink-0" />
//     //                     <span className="font-medium">{suggestion}</span>
//     //                   </li>
//     //                 ))}
//     //               </ul>
//     //             </div>
//     //           )}
//     //         </div>

//     //         <button
//     //           type="submit"
//     //           className="flex items-center justify-center gap-2 bg-[#FED547] hover:bg-black hover:text-[#FED547] text-black font-extrabold px-8 py-3.5 rounded-xl transition-all shadow-md shrink-0"
//     //         >
//     //           <Search className="w-4 h-4" />
//     //           SEARCH
//     //         </button>
//     //       </div>
//     //     </form>

//     //   </div>
//     // </section>
//     <section
//       className="relative transition-colors duration-300 overflow-hidden bg-gray-900 text-white flex flex-col justify-center"
//       style={{ 
//         backgroundImage: bannerData?.image_url ? `url(${bannerData.image_url})` : 'linear-gradient(135deg, #060606ff 0%, #393a3dff 55%, #8f929aff 100%)',
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         minHeight: '450px' // Banner ki minimum height jo image ke sath adjust hogi
//       }}
//     ></section>
//   );
// };

// export default Hero;
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { Search, MapPin, Briefcase, ChevronLeft, ChevronRight } from 'lucide-react';
import { stats } from '../mock/mockData'; 

const Hero = () => {
  const [city, setCity] = useState('');
  const [role, setRole] = useState('');
  const [dynamicCities, setDynamicCities] = useState([]);
  const [allJobs, setAllJobs] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHeroData = async () => {
      try {
        const [cityRes, jobsRes, bannerRes] = await Promise.all([
          api.get("/nav-filters"),
          api.get("/public-jobs"),
          api.get("/active-banners").catch(() => ({ data: { banners: [] } }))
        ]);
        
        setDynamicCities(cityRes.data.cities || []);
        setAllJobs(Array.isArray(jobsRes.data) ? jobsRes.data : []);
        if (bannerRes.data && bannerRes.data.banners) {
          setBanners(bannerRes.data.banners);
        }
      } catch (error) {
        console.error("Error fetching data for hero section", error);
      }
    };
    fetchHeroData();

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🌟 Auto-scroll every 4 seconds
  useEffect(() => {
    if (banners.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [banners.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? banners.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  const handleInputChange = (e) => {
    const val = e.target.value;
    setRole(val);

    if (val.trim().length > 0) {
      const filtered = allJobs.filter(job =>
        (job.title && job.title.toLowerCase().includes(val.toLowerCase())) ||
        (job.company && job.company.toLowerCase().includes(val.toLowerCase())) ||
        (job.category && job.category.toLowerCase().includes(val.toLowerCase()))
      );

      const uniqueTitles = [...new Set(filtered.map(j => j.title || j.category).filter(Boolean))].slice(0, 5);
      setSuggestions(uniqueTitles);
      setShowDropdown(uniqueTitles.length > 0);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setRole(suggestion);
    setShowDropdown(false);
  };

    const handleSearch = (e) => {
    e.preventDefault();
    setShowDropdown(false);

    let queryParams = new URLSearchParams();
    if (city) queryParams.append('city', city);
    if (role) queryParams.append('skill', role);

    navigate(`/job-listing?${queryParams.toString()}`);
  };

  return (
    <section className="relative overflow-hidden bg-gray-900 text-white flex flex-col justify-center group py-20 md:py-32">
      
      {/* 🌟 Background Images with contain size to prevent image cutting */}
      {banners.length > 0 ? (
        banners.map((banner, idx) => (
          <div
            key={banner.id || idx}
            className={`absolute inset-0 bg-no-repeat bg-center transition-all duration-1000 ease-in-out transform ${
              currentIndex === idx ? 'opacity-100 scale-100 z-0' : 'opacity-0 scale-105 pointer-events-none'
            }`}
            style={{
              backgroundImage: `url(${banner.image_url})`,
              backgroundSize: 'contain',
              backgroundColor: '#111827'
            }}
          />
        ))
      ) : (
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'linear-gradient(135deg, #060606ff 0%, #393a3dff 55%, #8f929aff 100%)' }}
        />
      )}

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50 z-1 pointer-events-none" />

      {/* Left and Right Arrow Navigation */}
      {banners.length > 1 && (
        <>
          <button 
            onClick={handlePrev} 
            className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-black/40 hover:bg-black/80 text-white p-3 rounded-full backdrop-blur-md transition-all opacity-60 group-hover:opacity-100 shadow-lg cursor-pointer"
            title="Previous Banner"
          >
            <ChevronLeft size={24} />
          </button>
          <button 
            onClick={handleNext} 
            className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-black/40 hover:bg-black/80 text-white p-3 rounded-full backdrop-blur-md transition-all opacity-60 group-hover:opacity-100 shadow-lg cursor-pointer"
            title="Next Banner"
          >
            <ChevronRight size={24} />
          </button>
        </>
      )}

      <div className="relative overflow-visible max-w-[1200px] mx-auto px-4 text-center z-10">
        
        {/* Fixed Height Container for Stable Layout */}
        <div className="relative h-[180px] md:h-[200px] flex flex-col items-center justify-center">
          {banners.length > 0 ? (
            banners.map((banner, idx) => (
              <div 
                key={banner.id || idx}
                className={`absolute inset-0 flex flex-col items-center justify-center transition-opacity duration-700 ease-in-out ${
                  currentIndex === idx ? 'opacity-100 z-10 pointer-events-auto' : 'opacity-0 z-0 pointer-events-none'
                }`}
              >
                <div className="inline-flex items-center gap-2 mb-3 px-4 py-1.5 rounded-full bg-white/10 border border-white/25 text-white/90 text-xs backdrop-blur-md shadow-sm">
                  <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                  {banner.subtitle || "India's No.1 Blue Collar & Entry-Level Job Portal"}
                </div>

                <h1 className="text-white font-extrabold text-3xl md:text-5xl lg:text-6xl tracking-tight leading-tight max-w-4xl mx-auto drop-shadow-md">
                  {banner.title || "Find the best job near you"}
                </h1>

                {banner.link_url && (
                  <div className="mt-3">
                    <a 
                      href={banner.link_url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-block bg-yellow-500 text-black text-xs font-extrabold px-6 py-2 rounded-xl hover:bg-yellow-400 transition-colors shadow-lg"
                    >
                      Learn More →
                    </a>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="inline-flex items-center gap-2 mb-3 px-4 py-1.5 rounded-full bg-white/10 border border-white/25 text-white/90 text-xs backdrop-blur-md">
                <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                India's No.1 Blue Collar & Entry-Level Job Portal
              </div>
              <h1 className="text-white font-extrabold text-3xl md:text-5xl lg:text-6xl tracking-tight leading-tight max-w-4xl mx-auto">
                Find the best job near you
              </h1>
            </div>
          )}
        </div>

        <p className="text-orange-200 font-medium mt-4 text-lg drop-shadow">
          <span className="text-white font-bold">{stats.vacancies}</span> active job vacancies to grab
        </p>

        {/* Dots Indicator */}
        {banners.length > 1 && (
          <div className="flex justify-center gap-2 mt-4">
            {banners.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`h-2 rounded-full transition-all duration-500 cursor-pointer ${currentIndex === idx ? 'w-8 bg-yellow-400' : 'w-2 bg-white/50'}`}
              />
            ))}
          </div>
        )}

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="mt-8 max-w-3xl mx-auto">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-3 flex flex-col md:flex-row items-stretch md:items-center gap-3 transition-colors duration-300 relative border border-gray-100 dark:border-gray-700">
            
            <div className="flex items-center gap-2 flex-1 px-4 py-3 bg-gray-50 dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 transition-colors duration-300 w-full">
              <MapPin className="w-5 h-5 text-gray-700 dark:text-white shrink-0" />
              <select
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="w-full text-sm font-semibold text-gray-700 dark:text-white bg-transparent outline-none appearance-none cursor-pointer"
              >
                <option value="" className="bg-white dark:bg-gray-900">Select City</option>
                {dynamicCities.map((c, index) => (
                  <option key={index} value={c} className="bg-white dark:bg-gray-900">{c}</option>
                ))}
              </select>
            </div>

            <div ref={dropdownRef} className="relative flex items-center gap-2 flex-1 px-4 py-3 bg-gray-50 dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 transition-colors duration-300 w-full">
              <Briefcase className="w-5 h-5 text-gray-700 dark:text-white shrink-0" />
              <input
                type="text"
                value={role}
                onChange={handleInputChange}
                onFocus={() => { if (role.trim() && suggestions.length > 0) setShowDropdown(true); }}
                placeholder="Enter job role, skill or company"
                autoComplete="off"
                className="w-full text-sm font-semibold text-gray-700 dark:text-white bg-transparent outline-none placeholder:text-gray-400 dark:placeholder-gray-400"
              />

              {showDropdown && suggestions.length > 0 && (
                <div className="absolute left-0 right-0 bottom-[130%] mb-2 bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl overflow-hidden text-left z-[99999]">
                  <ul className="max-h-60 overflow-y-auto divide-y divide-gray-800">
                    {suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          handleSuggestionClick(suggestion);
                        }}
                        className="px-5 py-3.5 hover:bg-gray-800 cursor-pointer text-sm text-white flex items-center gap-3 transition-colors"
                      >
                        <Search className="w-4 h-4 text-yellow-400 shrink-0" />
                        <span className="font-medium">{suggestion}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <button
              type="submit"
              className="flex items-center justify-center gap-2 bg-[#FED547] hover:bg-black hover:text-[#FED547] text-black font-extrabold px-8 py-3.5 rounded-xl transition-all shadow-md shrink-0 cursor-pointer"
            >
              <Search className="w-4 h-4" />
              SEARCH
            </button>
          </div>
        </form>

      </div>
    </section>
  );
};

export default Hero;